import type { KlientStatus } from '../api/klienti';
import { KLIENT_STATUS_DEF } from './klienti-config';
import { marketFlag, webHost, webHref } from './klienti-format';

export function MarketPill({ market, label }: { market: string | null; label?: string | null }) {
  if (!market) return <span className="text-muted">-</span>;
  return <span className="pill pill-flag"><span className="pill-flag-ico">{marketFlag(market)}</span>{label ?? market}</span>;
}

export function StatusPill({ status }: { status: KlientStatus }) {
  const def = KLIENT_STATUS_DEF[status];
  return <span className={`prototype-status ${def.className}`}>{def.label}</span>;
}

export function WebLink({ url }: { url: string | null }) {
  const host = webHost(url);
  if (!url || !host) return <span className="text-muted">-</span>;
  return (
    <a className="aff-web-link" href={webHref(url)} target="_blank" rel="noreferrer" title={url} onClick={(e) => e.stopPropagation()}>
      <i data-feather="globe" style={{ width: 14, height: 14 }} />
      <span className="aff-web-label">{host}</span>
    </a>
  );
}
